(function (Wishlist, $) {
  'use strict';

  // -----------------------------
  // Helpers
  // -----------------------------
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('user_wishlist') || '[]');
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    localStorage.setItem('user_wishlist', JSON.stringify(list || []));
  }

  function toast(message, type) {
    type = type || 'success';

    // If notify plugin exists, use it
    if (typeof $.notify === 'function') {
      $.notify(
        { icon: 'fa fa-heart', message: message },
        {
          type: type,
          placement: { from: 'top', align: 'right' },
          delay: 2500,
          z_index: 9999
        }
      );
      return;
    }

    // Fallback (if notify plugin not available)
    // Simple small div toast
    var id = 'wishlist-toast-fallback';
    var $t = $('#' + id);
    if (!$t.length) {
      $('body').append(
        '<div id="' + id + '" style="position:fixed;top:20px;right:20px;z-index:999999;background:#111;color:#fff;padding:10px 14px;border-radius:8px;font-size:14px;display:none;"></div>'
      );
      $t = $('#' + id);
    }
    $t.stop(true, true).text(message).fadeIn(200).delay(2000).fadeOut(200);
  }

  function updateWishlistCount() {
    var list = getWishlist();
    // If you want "3 items" instead of "3" change below line
    $('.wishlist-item-count').text(list.length);
  }

  function activateWishlistButtons() {
    var list = getWishlist();

    $('.wishlist-btn').each(function () {
      var handle = $(this).attr('data-product-handle') || $(this).data('product-handle');
      if (!handle) return;

      if (list.indexOf(handle) > -1) {
        $(this).addClass('is-active');
      } else {
        $(this).removeClass('is-active');
      }
    });
  }

  function removeNonWishlistItems() {
    if (window.location.pathname.indexOf('/pages/wishlist') === -1) return;

    var list = getWishlist();
    var visibleCount = 0;

    // Remove any tile/container not in wishlist
    $('.wishlist-tile-container').each(function () {
      var handle = $(this).attr('data-product-handle') || $(this).data('product-handle');
      if (!handle) return;

      if (list.indexOf(handle) === -1) {
        $(this).remove();
      } else {
        visibleCount++;
      }
    });

    // Also remove table rows (your <tr data-product-handle="...">)
    $('.wishlist_table tr[data-product-handle]').each(function () {
      var handle = $(this).attr('data-product-handle');
      if (!handle) return;

      if (list.indexOf(handle) === -1) {
        $(this).remove();
      } else {
        visibleCount++;
      }
    });

    // Hide loader
    $('.wishlist-loader').hide();

    // Empty state
    if (visibleCount <= 0) {
      $('.wishlist_table, .checkout').hide();
      $('.wishlist-grid--empty-list, .show-wishlist').show();
    } else {
      $('.wishlist_table, .checkout').show();
      $('.wishlist-grid--empty-list, .show-wishlist').hide();
    }
  }

  // -----------------------------
  // Events (use namespaced events to avoid duplicates)
  // -----------------------------
  function bindEvents() {
    // Remove old handlers first (important in Shopify theme editor)
    $(document).off('click.wishlistHeart');
    $(document).off('click.wishlistTrash');

    // ❤️ HEART CLICK (add/remove, stay on same page)
    $(document).on('click.wishlistHeart', '.wishlist-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var handle = $(this).attr('data-product-handle') || $(this).data('product-handle');
      if (!handle) return;

      var list = getWishlist();
      var idx = list.indexOf(handle);

      if (idx > -1) {
        list.splice(idx, 1);
        toast('Removed from wishlist', 'warning');
      } else {
        list.push(handle);
        toast('Added to wishlist', 'success');
      }

      setWishlist(list);

      // Update UI
      activateWishlistButtons();
      updateWishlistCount();
      removeNonWishlistItems();
    });

    // 🗑 TRASH CLICK (remove from wishlist page)
    // Works even if user clicks the <i> icon or the <a> wrapper
    $(document).on('click.wishlistTrash', '.wishlist-remove, .ti-trash', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $clicked = $(this);

      // Find handle from nearest parent that contains it
      var $container =
        $clicked.closest('[data-product-handle]'); // tbody or tr

      var handle =
        $container.attr('data-product-handle') ||
        $container.data('product-handle');

      if (!handle) return;

      var list = getWishlist().filter(function (h) {
        return h !== handle;
      });

      setWishlist(list);
      toast('Removed from wishlist', 'warning');

      // Remove row/tile
      // If it's inside a table row, remove the TR
      var $tr = $clicked.closest('tr');
      if ($tr.length) $tr.remove();
      // Also remove any wishlist container
      if ($container.length) $container.remove();

      // Update UI
      activateWishlistButtons();
      updateWishlistCount();
      removeNonWishlistItems();
    });
  }

  // -----------------------------
  // Init
  // -----------------------------
  Wishlist.init = function () {
    bindEvents();
    activateWishlistButtons();
    updateWishlistCount();
    removeNonWishlistItems();
  };

})(window.Wishlist = window.Wishlist || {}, jQuery);

// Run on page load
document.addEventListener('DOMContentLoaded', function () {
  if (window.Wishlist && typeof window.Wishlist.init === 'function') {
    window.Wishlist.init();
  }
});

// Run when Shopify editor reloads sections
document.addEventListener('shopify:section:load', function () {
  if (window.Wishlist && typeof window.Wishlist.init === 'function') {
    window.Wishlist.init();
  }
});